module.exports = __webpack_public_path__ + "static/media/13.0e21f158.wav";